module.exports = __webpack_public_path__ + "static/img/baolie-new.b78fd20a.png";